import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InvoiceRepository } from '../interfaces/invoice-repository.interface';
import { InvoiceExportRequest } from '../models/invoice-export.model';

@Injectable()
export class ExportInvoicesCsvUseCase {
  constructor(private readonly repository: InvoiceRepository) {}

  execute(request: InvoiceExportRequest): Observable<Blob> {
    return this.repository.exportCsv(request);
  }
}

